module.exports = __webpack_public_path__ + "img/successOrder.60219588.png";